export default String.raw`
{% if hideContent -%}
{% else -%}
    <dialog class="dialog report-review-popup-js">
        <div class="dialog__header"><h2>{{translations.ReportReview}}</h2>
            <button class="close-button close-js" aria-label="{{ translations.Close }}">
                <svg aria-hidden="true" height="20" width="20" class="svgIcon">
                    <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-solid"></use>
                </svg>
            </button>
        </div>
        <div class="dialog-content reportContent-popup form-js">
            <input type="hidden" name="__action" value="Contact/DSAReviewReport" >
            <input type="hidden" name="id" value="">
            <div class="inputs-container-js">
                <ul class="consentsList">
                    <li class="consentsList__li">
                        <div class="checkBoxes__container consentsContent">
                            <input id="RelatedToEUDirectiveOffenseYes" class="checkbox-input input-value-js" value="true" name="RelatedToEUDirectiveOffense" type="checkbox">
                            <label role="checkbox" tabindex="0" aria-checked="false" for="RelatedToEUDirectiveOffenseYes" class="tosLabel">
                                <span class="checkBoxes__checkIcon">
                                    <svg>
                                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                    </svg>
                                </span>
                                <span class="checkbox-name consentsContent">{{ translations.ReportStatementA | H }}</span>
                            </label>
                        </div>
                    </li>
                </ul>
                
                <div class="form__input-wrapper">
                    <label for="dsa-name" class="form__input-info input-info-js" data-type="text"><span class="required">* </span>{{ translations.InputNameOrCompany }}</label>
                    <input class="form__input-value input-value-js" id="dsa-name" type="text" name="name" value="{{ customer.Address.Name }}" required >
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                </div>

                <div class="form__input-wrapper">
                    <label for="dsa-email" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Email }}</label>
                    <input id="dsa-email" class="form__input-value input-value-js" type="email" name="email" value="{{ customer.Email }}" required >
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                    <div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
                </div>

                <div class="form__input-wrapper">
                    {% assign maxLength = 2000 -%}
                    <label for="dsa-textarea" class="form__input-info input-info-js text-overflow"><span class='required'>* </span>{{ translations.InputReportReviewTextArea }}</label>
                    <div class="scrollable"></div>
                    <textarea id="dsa-textarea" aria-label="{{ translations.InputReportReviewTextArea }}" class="form__input-value input-value-js" maxlength="2000" name="message" required></textarea>
                    <div class="characters-counter characters-counter-js"></div>
					<div class="characters-length characters-length-js">{{ translations.Com_MaxFieldSize | Format: maxLength }}</div>
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                </div>

                <ul class="consentsList">
                    <li class="consentsList__li">
                        <div class="checkBoxes__container consentsContent">
                            <input id="informationAccuracyConfirmation" class="checkbox-input input-value-js" value="true" name="informationAccuracyConfirmation" type="checkbox" required>
                            <label role="checkbox" tabindex="0" aria-checked="false" for="informationAccuracyConfirmation" class="channelLabel">
                                <span class="checkBoxes__checkIcon">
                                    <svg>
                                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                    </svg>
                                </span>
                                <span class="checkbox-name"><span class="required">* </span>{{ translations.ReportStatementB | H }}</span>
                            </label>
                            <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                        </div>
                    </li>
                    <li class="consentsList__li">
                        <div class="checkBoxes__container consentsContent">
                            <input id="trustedNotifierEntityAgreement" class="checkbox-input input-value-js" value="true" name="trustedNotifierEntityAgreement" type="checkbox">
                            <label role="checkbox" tabindex="0" aria-checked="false" for="trustedNotifierEntityAgreement" class="channelLabel">
                                <span class="checkBoxes__checkIcon">
                                    <svg>
                                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                    </svg>
                                </span>
                                <span class="checkbox-name">{{ translations.ReportStatementC | H }}</span>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>
            <div class='required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
            <button aria-label="{{ translations.Send }}" class="primary-action-button reportReviewBtn reportReviewBtn-js">
                {{ translations.Send }}
            </button>
        </div>
    </dialog>

    <div class="hidden-js">
        <input type="hidden" name="RelatedToEUDirectiveOffenseContent" value="{{translations.ReportStatementA | H}}">
        <input type="hidden" name="informationAccuracyConfirmationContent" value="{{translations.ReportStatementB | H}}">
        <input type="hidden" name="trustedNotifierEntityAgreementContent" value="{{translations.ReportStatementC | H}}">
    </div>
{% endif -%}
`